<template>
  <div class="ft-modal-container">
    <b-button style="letter-spacing: 0.75px;" class="ft-button-link no-padding text-blue" @click="onAccountChangeClick" variant="link"
              v-b-modal.ft-modal>
      {{ $t('message.changeAccountLabelTxt') }}
    </b-button>

    <b-modal id="ft-modal" class="ft-modal" hide-footer hide-header @hidden="resetForm" title="add-supplier-modal">
      <b-container v-if="isAddSupplier">
        <b-row class="ft-modal-header">
          <b-col cols="12">
            <h4>{{ $t('message.addSupplierTitleText') }}</h4>
            <p>{{ $t('message.addSupplierSubText') }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form @submit.prevent="onSubmit" @reset="resetForm" id="add-supplier-form">
              <b-form-group
                  :label="$t('message.addSupplierNameLabelText')"
                  label-for="input-1"
              >
                <b-form-input
                    id="supplier-name"
                    type="text"
                    name="name"
                    v-model.trim="name"
                    @input="$v.name.$touch()"
                    :state="$v.name.$dirty ? !$v.name.$error : null"
                    :placeholder="$t('message.addSupplierNamePlaceholderText')"
                    autocomplete="off"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ $t('message.addSupplierNameErrorText') }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group :label="$t('message.addSupplierSupplierTypeLabel')" label-for="supplier-type">
                <b-form-select
                    id="supplier-type"
                    v-model="supplierType"
                    :options="supplierTypes"
                    :state="$v.supplierType.$dirty ? !$v.supplierType.$error : null"
                ></b-form-select>
                <div class="form-feedback error-text" v-if="isSupplierTypeDirty && supplierType == null">
                  {{ $t('message.addSupplierSupplierTypeErrorText') }}
                </div>
              </b-form-group>
              <b-form-group
                  :label="$t('message.addSupplierPhoneLabelText')"
                  label-for="input-1"
              >
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text
                        :class="{ 'form-group--error': $v.phone.$error,  'is-valid': (phone != '' && !$v.phone.$error)}">
                      +91
                    </b-input-group-text>
                  </template>
                  <b-form-input
                      id="supplier-contact"
                      type="text"
                      name="phone"
                      v-model.trim="phone"
                      @input="$v.phone.$touch()"
                      :state="$v.phone.$dirty ? !$v.phone.$error : null"
                      placeholder=""
                      autocomplete="off"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ $t('message.addSupplierPhoneErrorText') }}
                  </b-form-invalid-feedback>
                  <div class="form-feedback error-text" v-if="!$v.phone.$error && phoneErrorStatus">
                    {{ phoneErrorMsg }}
                  </div>
                </b-input-group>
              </b-form-group>
              <div class="ft-modal-form-control">
                <b-button class="ft-button-link" variant="link" type="reset">{{
                    $t('message.addSupplierCancelBtnText')
                  }}
                </b-button>
                <b-button class="ft-button-link" variant="link" type="submit">
                  <b-spinner v-if="showSaveSupplierLoader" small label="Small Spinner"></b-spinner>
                  {{ $t('message.addSupplierAddBtnText') }}
                </b-button>
              </div>
            </b-form>

          </b-col>

        </b-row>
      </b-container>

      <b-container v-if="!isAddSupplier">
        <b-row class="ft-modal-header">
          <b-col cols="12">
            <h4>{{ $t('message.addSupplierTitleText') }}</h4>
            <p>{{ $t('message.addSupplierNotifyText') }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="ft-modal-form-control">
              <b-button class="ft-button-link" variant="link" @click="resetForm">Ok</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import {required, minLength, maxLength, numeric} from 'vuelidate/lib/validators'
import axios from 'axios'

import Config from '../config/config.js'
import {identify, MX_TRACK} from "../utils/Mixpanel";


const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL

export default {
  props: {
    demandDetails: Object
  },
  data() {
    return {
      name: '',
      phone: '',
      supplierType: null,
      supplierTypes: [],
      isSupplierTypeDirty: false,
      phoneErrorStatus: false,
      phoneErrorMsg: '',
      showSaveSupplierLoader: false,
      isAddSupplier: true
    }
  },
  mounted() {
    this.updateSupplierList()
  },
  validations: {
    name: {
      required,
      minLength: minLength(1)
    },
    phone: {
      numeric,
      required,
      minLength: minLength(10),
      maxLength: maxLength(10)
    },
    supplierType: {
      required
    }
  },
  watch: {
    phone() {
      if (this.phoneErrorStatus) {
        this.phoneErrorStatus = false
      }
    },
    $route(to, from) {
      if (to.params.lang != from.params.lang) {
        this.updateSupplierList()
      }
    }
  },
  methods: {
    onAccountChangeClick() {
      this.mxTrackAccountChange();
    },
    updateSupplierList() {
      const supplierTypes = [{
        value: null,
        text: this.$t('message.dropdownLabelText')
      }, ...Config.supplierTypes[this.$route.params.lang]]
      this.supplierTypes = supplierTypes
    },
    async onSubmit() {
      // const that = this
      this.showSaveSupplierLoader = true

      this.isSupplierTypeDirty = this.supplierType == null

      if (this.$v.$invalid) {
        this.$v.$touch()
        this.phoneErrorMsg = this.$t('message.addSupplierPhoneErrorText')
      } else {
        const reqData = {
          name: this.name,
          phone: this.phone,
          type: [this.supplierType]
        }
        try {
          const {data} = await axios.post(`${API_BASE_URL}/supplier/${this.$route.params.id}`, reqData)
          if (data.success) {
            this.mxConfirmCreateAccount(data.value);
            this.resetForm()
            this.$router.push(`/${this.$route.params.lang}/demand/${data.value}`)
          }
        } catch (error) {
          if (error.toJSON().message === 'Network Error' || !window.navigator.onLine) {
            this.isAddSupplier = false
          } else if (error.response && error.response.data) {
            this.phoneErrorStatus = true
            this.phoneErrorMsg = this.$t('message.addSupplierPhoneErrorText2')
          }
        }
      }
      this.showSaveSupplierLoader = false
    },
    resetForm() {
      this.name = ''
      this.phone = ''
      this.supplierType = null
      this.isSupplierTypeDirty = false
      this.isAddSupplier = true
      this.phoneErrorStatus = false
      this.$v.$reset()
      this.$bvModal.hide('ft-modal')
    },
    async mxConfirmCreateAccount(demandId) {
      const mx_prop = {
        time: new Date().getTime(),
        page_src: this.$route.name,
      }
      if (demandId) {
        const {data} = await axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_URL}/demand/details/${demandId}`)
        if (data && data.success && data.value) {
          const {supplier_name, contact, supplier_id, user_type} = data.value
          identify(supplier_id)
          mx_prop.user_type = user_type;
          mx_prop.user_name = supplier_name;
          mx_prop.phone_number = contact;
          mx_prop.user_id = supplier_id;
        }
      }
      MX_TRACK(Config.MIXPANEL_EVENTS.CHANGE_ACC_SUBMIT, mx_prop)
    },
    async mxTrackAccountChange() {
      const {supplier_name, contact, supplier_id, user_type} = this.demandDetails
      identify(supplier_id)
      const mx_prop = {
        time: new Date().getTime(),
        page_src: this.$route.name,
        user_type: user_type,
        user_name: supplier_name,
        phone_number: contact,
        user_id: supplier_id,
      }
      MX_TRACK(Config.MIXPANEL_EVENTS.CHANGE_ACC, mx_prop)
    }
  }
}
</script>

<style lang="scss">

.ft-modal-container {
  display: inline;
}


.ft-button-link {
  margin: 10px 0 10px 20px;
  color: #1F1F1F;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  

  &:hover {
    text-decoration: none;
    color: #1F1F1F;

  }

  &:focus {
    text-decoration: none;
    box-shadow: none;
  }
}

.ft-modal-form-control {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin-top: 30px;

}
</style>
